module.exports = __webpack_public_path__ + "static/img/qrCodeCn-clientBig.92b7997e.png";